module.exports = __webpack_public_path__ + "static/media/swarm.4c3f8491.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/swarm.png
// module id = 471
// module chunks = 0